var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHide(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 19,
    viewBox: "0 0 21 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.0005 17.9999L20.5 1",
    stroke: "#B6B5D7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.25 6.6368C17.94 3.01405 14.56 0.928223 11 0.928223C9.22 0.928223 7.49 1.44718 5.91 2.41525C4.33 3.39329 2.91 4.82044 1.75 6.6368C0.75 8.20367 0.75 10.7486 1.75 12.3154C4.06 15.9482 7.44 18.024 11 18.024C12.78 18.024 14.51 17.5051 16.09 16.537C17.67 15.559 19.09 14.1318 20.25 12.3154C21.25 10.7586 21.25 8.20367 20.25 6.6368ZM11 13.5131C8.76 13.5131 6.96 11.7067 6.96 9.48112C6.96 7.25557 8.76 5.44918 11 5.44918C13.24 5.44918 15.04 7.25557 15.04 9.48112C15.04 11.7067 13.24 13.5131 11 13.5131Z",
    fill: "#B6B5D7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0004 6.62671C9.43039 6.62671 8.15039 7.90415 8.15039 9.481C8.15039 11.0479 9.43039 12.3253 11.0004 12.3253C12.5704 12.3253 13.8604 11.0479 13.8604 9.481C13.8604 7.91413 12.5704 6.62671 11.0004 6.62671Z",
    fill: "#B6B5D7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHide);
export default __webpack_public_path__ + "static/media/hide.d5c3951e57c69d547bb5b57dfec145cc.svg";
export { ForwardRef as ReactComponent };